import { getComprobanteAfip, getEstadosFactura, getSectorDestino } from "@/services/compra.services.js";

export const fetchComprobantesAfip = async () => {
  try {
    const data = await getComprobanteAfip();
    return data || [];
  } catch (error) {
    console.error('Error al obtener comprobantes AFIP:', error);
    return [];
  }
};


export const fetchEstadosFactura = async () => {
  try {
    const data = await getEstadosFactura();
    return data || [];
  } catch (error) {
    console.error('Error al obtener estados de factura:', error);
    return [];
  }
};

export const fetchModalFilterData = async () => {
  try {
    const [comprobantes, estadosFactura] = await Promise.all([
      fetchComprobantesAfip(),
      fetchEstadosFactura()
    ]);

    return {
      comprobantes,
      estadosFactura
    };
  } catch (error) {
    console.error('Error al obtener datos del modal de filtros:', error);
    return {
      comprobantes: [],
      estadosFactura: []
    };
  }
};

export const fetchSectoresDropdown = async (username, centroCosto) => {
  try {
    const data = await getSectorDestino(username, centroCosto);
    return data || [];
  } catch (error) {
    console.error("Error al obtener sectores:", error);
    return [];
  }
};